function init() {
  document.querySelectorAll('.jp-header-banner >.elementor-widget-image >img').forEach(img => {
    img.sizes= "(max-width: 770px) 200vw, (max-width: 1024px) 120vw, 100vw";
  });
}

export default { init };